import { useCallback, useState } from "react";
import { useFormApi } from "@avinet/adaptive-ui-core/form/useForm";
import { useTranslate } from "@avinet/adaptive-ui-translate";
import useWizardFormTree from "../../../hooks/useWizardFormTree";
import Survey from "../../../types/Survey";
import { LayoutRenderer, LayoutRendererProps } from "../FormRenderer";
import WizardPageRenderer from "./WizardPageRenderer";
import WizardSummaryRenderer from "./WizardSummaryRenderer";
import "./WizardLayoutRenderer.scss";

const WizardLayoutRenderer: LayoutRenderer = ({
  survey,
}: LayoutRendererProps) => {
  const t = useTranslate("LayoutRenderer");
  const { title, schema, groups } = survey;
  const tree = useWizardFormTree(schema, groups);
  const form = useFormApi<Survey>();
  const [page, setPage] = useState(0);
  const entry = tree[page] ?? {};
  const isSummary = page === tree.length && page > 0;

  const handleSubmit = useCallback(
    (e) => {
      if (isSummary) {
        form.submit(e);
      } else {
        e.preventDefault();
        setPage((page) => page + 1);
      }
    },
    [isSummary, form]
  );

  return (
    <>
      <form
        className={
          `wizard-page wizard-page-${
            isSummary
              ? "summary"
              : `page wizard-${entry.type} wizard-page-${page}`
          } ` +
          (isSummary
            ? ""
            : entry.type === "section" &&
              entry.children[0].section.type.startsWith("geometry")
            ? "wizard-geometry"
            : "")
        }
        onSubmit={handleSubmit}
      >
        {page === 0 && (
          <header>
            <img
              className="logo"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
              alt=""
            />
          </header>
        )}
        {page === 0 && <h1>{title}</h1>}
        {!isSummary ? (
          !entry?.children ? (
            <p>{t("emptySchema")}</p>
          ) : (
            <WizardPageRenderer
              entry={entry}
              onPrev={
                page !== 0 ? () => setPage((page) => page - 1) : undefined
              }
            />
          )
        ) : (
          <WizardSummaryRenderer
            tree={tree}
            onPrev={page !== 0 ? () => setPage((page) => page - 1) : undefined}
          />
        )}
      </form>
    </>
  );
};

export default WizardLayoutRenderer;
